import { getStore } from 'store';
import { checkIsChineseInput, checkIsContainsAlphabet, checkIsDomain } from 'utility/checkValidations';
import { validateEmail } from 'utility/general';
import { checkPasswordValidity } from 'utility/general';
import { NO_ALPHABET } from './frontendMessage';

export default function textFieldValidator() {
    const { getState } = getStore();
    const systemMessage = getState().systemMessage.systemMessage;

    const isRequired = (value) => {
        const tempError = [];

        if (value === undefined || value === null || value === '') {
            tempError.push(systemMessage.required);
        }

        // if (!value) {
        //     tempError.push(systemMessage.required);
        // }
        return tempError;
    };

    const isEmail = (value) => {
        const tempError = [];
        const isValidEmail = validateEmail(value);
        if (!isValidEmail) {
            tempError.push(systemMessage.invalidEmail_001);
        }
        return tempError;
    };

    const disableChinese = (value) => {
        const tempError = [];
        const isValid = checkIsChineseInput(value);
        if (isValid) {
            tempError.push(systemMessage.chineseNotAllowedInput);
        }
        return tempError;
    };

    const checkPassword = (value) => {
        const tempError = [];
        if (!checkPasswordValidity(value)) {
            tempError.push(systemMessage.passCode_002);
        }
        return tempError;
    };
    const checkConfirmPassword = (confirmPasswordNotMatchPassword) => {
        const tempError = [];
        if (confirmPasswordNotMatchPassword) {
            tempError.push(systemMessage.passCode_003);
        }
        return tempError;
    };

    const disableAlphabet = (value) => {
        const tempError = [];
        if (checkIsContainsAlphabet(value)) {
            tempError.push(NO_ALPHABET);
        }
        return tempError;
    };

    const isDomain = (value) => {
        const tempError = [];
        if (!checkIsDomain(value)) {
            tempError.push(systemMessage.invalidEmailDomain);
        }
        return tempError;
    };

    // const checkNull = (value) => {
    //     const tempError = [];
    //     if (value === null || value === undefined) {
    //         tempError.push(systemMessage.required);
    //     }
    //     return tempError;
    // };

    return {
        isRequired,
        isEmail,
        disableChinese,
        checkPassword,
        checkConfirmPassword,
        isDomain,
        disableAlphabet,
        // checkNull,
    };
}
